/**
 * Asset resolution for the insurance coverage checker. The check mark is
 * local (public/insurance-checker/); service icons are the site's product
 * pictures on Blob; insurer logos come from the CMS.
 */

import { blobMediaUrl } from "@/lib/blob-url"

const ASSET_BASE = "/insurance-checker"

/** Resolve a local coverage-checker asset path under public/insurance-checker/. */
export function assetUrl(path: string): string {
  if (path.startsWith("http")) return path
  return `${ASSET_BASE}${path}`
}

/** Reads the logo URL off an insurer doc fetched from the CMS (Vercel Blob /
 * CMS media URL — already absolute, resolved in insurer-cms.ts). */
export function getInsurerLogoUrl(
  insurer: { logo?: { url: string } | null } | undefined
): string | undefined {
  return insurer?.logo?.url || undefined
}

type ServiceIcon = {
  icon: string
  bg: string
  border?: boolean
  photo?: boolean
}

/** Service icon config — keyed by service ID. A finite set of brand assets. */
export function getServiceIcon(id: string): ServiceIcon | undefined {
  return SERVICE_ICON_CONFIGS[id]
}

const BLOOD_TUBE: ServiceIcon = {
  icon: blobMediaUrl("/images/mega-menu/tube-advanced.webp"),
  bg: "#fff",
  photo: true,
}

const SERVICE_ICON_CONFIGS: Record<string, ServiceIcon> = {
  // The scanner renders from /pricing's MRI cards (data/product-info.ts),
  // shot on white, so the tile is white too.
  "core-mri": {
    icon: blobMediaUrl("/images/addons/mri/mri-core.webp"),
    bg: "#fff",
    photo: true,
  },
  "advanced-mri": {
    icon: blobMediaUrl("/images/addons/mri/mri-advanced.webp"),
    bg: "#fff",
    photo: true,
  },
  "pro-mri": {
    icon: blobMediaUrl("/images/addons/mri/mri-pro.webp"),
    bg: "#fff",
    photo: true,
  },
  // The navbar's blood tube (mega-menu), for the blood test and the
  // membership row that stands for it in the check-up step.
  "blood-test": BLOOD_TUBE,
  "membership-group": BLOOD_TUBE,
}
